import { BaseDto } from './base.dto';
import { ProductDto } from './product.dto';

export class OrderPosTableProductDto extends BaseDto{
    orderId?: number;
    cartId: number;
    product: ProductDto;
    menuId: number;
    merchantId: number;
    quantity: number;
    subtotal: number;
    guestId?: number;
    isPaid?: boolean;
    isVoid?: boolean;
    managerEmployeeId?: number;
    cartItemCreatedDate?: Date;
    operatorEmployeeId?: number;
    posDeviceId?: number;
}